import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { DomainProvider } from './contexts/DomainContext';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import Callback from './pages/Callback';
import Logout from './pages/Logout';
import Impersonate from './pages/Impersonate';
import EmailVerification from './pages/EmailVerification';
import './App.css';

function App() {
  return (
    <Router>
      <DomainProvider>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/verify-email" element={<EmailVerification />} />
          <Route path="/callback" element={<Callback />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/impersonate" element={<Impersonate />} />
        </Routes>
      </DomainProvider>
    </Router>
  );
}

export default App;
